import type { RouteRecordRaw } from 'vue-router';

type AxRouteComponent = NonNullable<RouteRecordRaw['component']>;

export interface AxResourceRouteDefinition {
  path: string;
  name: string;
  menuCode: string;
  permission: string;
  title: string;
  endpoint: string;
}

export interface CreateAxResourceRouteOptions {
  component: AxRouteComponent;
  props?: Record<string, unknown>;
}

function getAdminChildRoutes(routes: RouteRecordRaw[], errorPrefix: string): RouteRecordRaw[] {
  const adminRoute = routes.find((r) => r.name === 'admin-root');
  if (!adminRoute || !Array.isArray(adminRoute.children)) {
    throw new Error(
      `${errorPrefix} coreRoutes 의 admin layout 라우트(name: 'admin-root') 를 찾지 못했습니다.`,
    );
  }
  return adminRoute.children;
}

export function replaceAdminDashboardRoute(
  routes: RouteRecordRaw[],
  replacement: { component: AxRouteComponent; meta?: RouteRecordRaw['meta'] },
  errorPrefix = '[core-fe]',
): void {
  const children = getAdminChildRoutes(routes, errorPrefix);
  const dashIdx = children.findIndex((c) => c.name === 'dashboard');
  if (dashIdx < 0) {
    throw new Error(`${errorPrefix} coreRoutes 의 dashboard 라우트를 찾지 못했습니다.`);
  }

  const prev = children[dashIdx]!;
  children[dashIdx] = {
    ...prev,
    component: replacement.component,
    meta: {
      ...(prev.meta ?? {}),
      ...(replacement.meta ?? {}),
    },
  } as RouteRecordRaw;
}

export function appendAdminChildRoutes(
  routes: RouteRecordRaw[],
  childRoutes: RouteRecordRaw[],
  errorPrefix = '[core-fe]',
): void {
  getAdminChildRoutes(routes, errorPrefix).push(...childRoutes);
}

export function createAxResourceRoute(
  route: AxResourceRouteDefinition,
  options: CreateAxResourceRouteOptions,
): RouteRecordRaw {
  return {
    path: route.path,
    name: route.name,
    component: options.component,
    props: {
      title: route.title,
      permission: route.permission,
      endpoint: route.endpoint,
      menuCode: route.menuCode,
      ...(options.props ?? {}),
    },
    meta: {
      requiresAuth: true,
      menuCode: route.menuCode,
      permission: route.permission,
    },
  };
}
